import { lazy } from 'react';

export const AdminDigitalProductsPage = lazy(() => import('./AdminDigitalProductsPage'));
